const r=(r,o)=>r.priority-o.priority,o=o=>o.sort(r);export{o as sortPriority};
